import { NgModule } from '@angular/core';
import { ControlsIconsModule } from './icons.module';

// Base Components
import { ViewComponent } from './base/view.component';
import { InputComponent } from './base/input.component';

// Input Container
import { InputContainerComponent } from './input-container/input-container.component';

// Comments Components
import { CommentsComponent } from './comments/comments.component';
import { CommentsModalComponent } from './comments/comments-modal.component';

// Text Components
import { TextViewComponent } from './inputs/text-view.component';
import { TextInputComponent } from './inputs/text-input.component';

// Number Components
import { NumberViewComponent } from './inputs/number-view.component';
import { NumberInputComponent } from './inputs/number-input.component';

// Date Components
import { DateViewComponent } from './inputs/date-view.component';
import { DateInputComponent } from './inputs/date-input.component';

// Checkbox Components
import { CheckboxViewComponent } from './inputs/checkbox-view.component';
import { CheckboxInputComponent } from './inputs/checkbox-input.component';

// List Components
import { TextListViewComponent, NumberListViewComponent } from './inputs/list-view.component';
import { TextListInputComponent, NumberListInputComponent } from './inputs/list-input.component';

// Multiline Text Components
import { MultilineTextViewComponent } from './inputs/multiline-text-view.component';
import { MultilineTextInputComponent } from './inputs/multiline-text-input.component';

// Textarea Components
import { TextareaInputComponent } from './inputs/textarea-input.component';
import { TextareaModalComponent } from './inputs/textarea-modal.component';

// Typeahead Component
import { TypeaheadInputComponent } from './inputs/typeahead-input.component';

// Alt-Neu Components
import { AltNeuTextViewComponent } from './inputs/alt-neu-text-view.component';
import { AltNeuTextInputComponent } from './inputs/alt-neu-text-input.component';
import { AltNeuListViewComponent } from './inputs/alt-neu-list-view.component';
import { AltNeuTextListInputComponent } from './inputs/alt-neu-list-input.component';
import { AltNeuTypeaheadInputComponent } from './inputs/alt-neu-typeahead-input.component';

// Comment Indicator
import { CommentIndicatorComponent } from './inputs/comment-indicator.component';

// Layout Components
import { SimpleLayoutComponent } from './simple-layout/simple-layout.component';

// Table Row Comments
import { TableRowCommentsComponent } from './table-row-comments/table-row-comments.component';

// Help Components
import { HelpComponent } from './help/help.component';
import { HelpModalComponent } from './help/help-modal.component';

const BASE_COMPONENTS = [
	ViewComponent,
	InputComponent,
	InputContainerComponent
];

const COMMENTS_COMPONENTS = [
	CommentsComponent,
	CommentsModalComponent
];

const TEXT_COMPONENTS = [
	TextViewComponent,
	TextInputComponent
];

const NUMBER_COMPONENTS = [
	NumberViewComponent,
	NumberInputComponent
];

const DATE_COMPONENTS = [
	DateViewComponent,
	DateInputComponent
];

const CHECKBOX_COMPONENTS = [
	CheckboxViewComponent,
	CheckboxInputComponent
];

const LIST_COMPONENTS = [
	TextListViewComponent,
	NumberListViewComponent,
	TextListInputComponent,
	NumberListInputComponent
];

const MULTILINE_COMPONENTS = [
	MultilineTextViewComponent,
	MultilineTextInputComponent
];

const TEXTAREA_COMPONENTS = [
	TextareaInputComponent,
	TextareaModalComponent
];

const TYPEAHEAD_COMPONENTS = [
	TypeaheadInputComponent
];

const ALT_NEU_COMPONENTS = [
	AltNeuTextViewComponent,
	AltNeuTextInputComponent,
	AltNeuListViewComponent,
	AltNeuTextListInputComponent,
	AltNeuTypeaheadInputComponent
];

const INDICATOR_COMPONENTS = [
	CommentIndicatorComponent
];

const LAYOUT_COMPONENTS = [
	SimpleLayoutComponent
];

const TABLE_ROW_COMMENTS = [
	TableRowCommentsComponent
];

const HELP_COMPONENTS = [
	HelpComponent,
	HelpModalComponent
];

@NgModule({
	imports: [
		ControlsIconsModule,
		// All standalone components
		...BASE_COMPONENTS,
		...COMMENTS_COMPONENTS,
		...TEXT_COMPONENTS,
		...NUMBER_COMPONENTS,
		...DATE_COMPONENTS,
		...CHECKBOX_COMPONENTS,
		...LIST_COMPONENTS,
		...MULTILINE_COMPONENTS,
		...TEXTAREA_COMPONENTS,
		...TYPEAHEAD_COMPONENTS,
		...ALT_NEU_COMPONENTS,
		...INDICATOR_COMPONENTS,
		...LAYOUT_COMPONENTS,
		...TABLE_ROW_COMMENTS,
		...HELP_COMPONENTS
	],
	exports: [
		...BASE_COMPONENTS,
		...COMMENTS_COMPONENTS,
		...TEXT_COMPONENTS,
		...NUMBER_COMPONENTS,
		...DATE_COMPONENTS,
		...CHECKBOX_COMPONENTS,
		...LIST_COMPONENTS,
		...MULTILINE_COMPONENTS,
		...TEXTAREA_COMPONENTS,
		...TYPEAHEAD_COMPONENTS,
		...ALT_NEU_COMPONENTS,
		...INDICATOR_COMPONENTS,
		...LAYOUT_COMPONENTS,
		...TABLE_ROW_COMMENTS,
		...HELP_COMPONENTS,
		ControlsIconsModule
	]
})
export class LuzulaControlsModule { }
